<template>
  <div class="header">
    <v-container class="header_in">
      <div class="header_logos">
        <p class="header_logos-1">
          <img
            src="../assets/logo_suiminhensachi_white.png"
            alt="睡眠偏差値® for BIZ"
            class="header_logo"
          />
        </p>
      </div>
      <v-app-bar-nav-icon
        @click="drawer = true"
        class="header_drawerBtn d-xs-block d-sm-none"
        color="#fff"
      ></v-app-bar-nav-icon>
      <div class="header_info d-none d-xs-none d-sm-block">
        <div
          style="margin: 0 0 4px auto; color: white; font-weight: bold"
          v-if="getLoginState == true"
        >
          <v-icon dark>mdi-account-circle</v-icon>
          <span
            v-if="returnLoginUserEmail == '' || returnLoginUserEmail == null"
            class="text-capitalize"
          >
            {{ returnLoginUserName }}
          </span>
          <span v-if="returnLoginUserEmail != ''">
            {{ returnLoginUserEmail }}
          </span>
        </div>
        <button
          class="btn_header"
          v-on:click="toTopPath"
          v-if="getLoginState == false"
        >
          {{ this.texts.back_to_top }}
        </button>

        <v-select
          :items="getLanguages"
          :value="getLanguage"
          @input="updateLanguage"
        ></v-select>

        <button
          class="btn_header"
          v-on:click="toAnalyticsPath"
          v-if="
            this.getBeforePath == '/analytics' && this.$route.path != '/mytop'
          "
        >
          {{ this.texts.back_to_report }}
        </button>
        

        <button
          class="btn_header"
          v-on:click="toLoginPath"
          v-if="this.$route.path == '/auth' && this.getFormState != 'signIn'"
        >
          {{ this.texts.back_to_login }}
        </button>
        
        <button
          class="btn_header"
          v-on:click="toSleepTestTopPath"
          v-if="
            getLoginState == true &&
            this.$route.path == '/sleepTestDetail'
          "
        >
           コンテンツ一覧に戻る
        </button>

        <button
          class="btn_header"
          v-on:click="toSleepTestDetailPath"
          v-if="
            getLoginState == true &&
            this.$route.path == '/sleepTestMovie'
          "
        >
           動画一覧に戻る
        </button>

        <button
          class="btn_header"
          v-on:click="toMyPagePath"
          v-if="
            getLoginState == true &&
            this.$route.path != '/mytop' &&
            this.getBeforePath != '/analytics'
          "
        >
          {{ this.texts.back_to_mytop }}
        </button>
        <button
          class="btn_header"
          v-on:click="signOut"
          v-if="getLoginState == true"
        >
          {{ this.texts.signout }}
        </button>
        
      </div>
      <v-navigation-drawer
        class="header_drawer"
        v-model="drawer"
        fixed
        temporary
        right
      >
        <v-list-item v-if="getLoginState == true">
          <v-list-item-icon>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <span
            v-if="returnLoginUserEmail == '' || returnLoginUserEmail == null"
            class="text-capitalize"
          >
            {{ returnLoginUserName }}
          </span>
          <span v-if="returnLoginUserEmail != ''">
            {{ returnLoginUserEmail }}
          </span>
          </v-list-item-title>
        </v-list-item>

        <v-select class="header_drawer_select"
          :items="getLanguages"
          :value="getLanguage"
          @input="updateLanguage"
        ></v-select>

        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group
            v-model="group"
            active-class="deep-purple--text text--accent-4"
          >
            <v-list-item v-on:click="toTopPath" v-if="getLoginState == false">
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-title>TOPに戻る</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-on:click="toAnalyticsPath"
              v-if="
                this.getBeforePath == '/analytics' &&
                this.$route.path != '/mytop'
              "
            >
              <v-list-item-icon>
                <v-icon>mdi-arrow-left</v-icon>
              </v-list-item-icon>
              <v-list-item-title>分析ページに戻る</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-on:click="toMyPagePath"
              v-if="
                getLoginState == true &&
                this.$route.path != '/mytop' &&
                this.getBeforePath != '/analytics'
              "
            >
              <v-list-item-icon>
                <v-icon>mdi-arrow-left</v-icon>
              </v-list-item-icon>
              <v-list-item-title>マイページに戻る</v-list-item-title>
            </v-list-item>

            
            <v-list-item v-on:click="signOut" v-if="getLoginState == true">
              <v-list-item-icon>
                <v-icon>mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>サインアウト</v-list-item-title>
            </v-list-item>

          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-container>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import navigationTextJa from "../assets/NavigationTextsJa";
import navigationTextEn from "../assets/NavigationTextsEn";
import navigationTextCh from "../assets/NavigationTextsCh";

export default {
  beforeMount() {
    if (this.getLanguage == "日本語") {
      this.texts = navigationTextJa;
    } else if (this.getLanguage == "English") {
      this.texts = navigationTextEn;
    } else if (this.getLanguage == "中文") {
      this.texts = navigationTextCh;
    }
  },
  data() {
    return {
      beforePath: this.getBeforePath,
      drawer: false,
      texts: "",
    };
  },
  computed: {
    returnLanguage() {
      return this.getLanguage;
    },
    returnLoginUserEmail() {
      return this.getLoginUserInfo["email"];
    },
    returnLoginUserName() {
      return this.getLoginUserInfo["name"];
    },
    ...mapGetters([
      "getLoginState",
      "getFormState",
      "getLoginUserId",
      "getLoginUserInfo",
      "getBeforePath",
      "getLanguages",
      "getLanguage",
    ]),
  },
  watch: {
    returnLanguage() {
      // eslint-disable-next-line
      if (this.getLanguage == "日本語") {
        // eslint-disable-next-line
        this.texts = navigationTextJa;
      } else if (this.getLanguage == "English") {
        // eslint-disable-next-line
        this.texts = navigationTextEn;
      } else if (this.getLanguage == "中文") {
        // eslint-disable-next-line
        this.texts = navigationTextCh;
      }
    },
  },
  methods: {
    ...mapMutations(["setValueToLanguage"]),
    updateLanguage(e) {
      this.$store.commit("setValueToLanguage", e);
    },
    toSleepTestTopPath(){
      this.$router.push("/sleepTestTop");
    },
    toSleepTestDetailPath(){
      this.$router.push("/sleepTestDetail");
    },
    toTopPath() {
      this.$router.push("/");
    },
    toMyPagePath() {
      this.$router.push("/mytop");
    },
    toAuthPath() {
      this.$router.push("/auth");
    },
    toAnalyticsPath() {
      this.$router.push("/analytics");
    },
    toLoginPath() {
      this.$store.commit("setValueToFormState", "signIn");
    },
    async signOut() {
      localStorage.setItem("susiminhensachiLoginType", "id");
      await Auth.signOut();
      AmplifyEventBus.$emit("authState", "signedOut");
      this.$router.push("/mytop");
    },
  },
};
</script>
<style lang="scss">
$xs: "320px";
$sm: "480px";
$md: "800px";
.btn_header {
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 12px;
  padding: 6px 8px;
  line-height: 1;
  border-radius: 20px;
  & + & {
    margin-left: 8px;
  }
}
.header {
  background: #5592c6;
  padding: 16px;
  @media screen and (max-width: $md) {
    padding: 10px 12px 0;
  }
  &_in {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  &_logo {
    width: 200px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 24px;
    @media screen and (max-width: $md) {
      width: 150px;
      margin-right: 0;
    }
  }
  &_logos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    @media screen and (max-width: $md) {
      justify-content: center;
      &-1 {
        margin: 0 !important;
      }
      &-2 {
        position: absolute;
        top: 12px;
        left: 16px;
      }
    }
  }
  &_info {
    text-align: right;
    display: block;
    @media screen and (max-width: $md) {
      font-size: 14px;
    }
  }
  &_drawerBtn {
    position: absolute;
    top: -36px;
    right: -8px;
    @media screen and (max-width: $md) {
      top: 12px;
      right: 12px;
    }
  }
  &_drawer_select {
    margin: 0 auto;
    width: 90%;
  }
}
</style>
